/* ============================================================
   PAWS · Custom Slide Cart controller
   Replicates AMP Slide Cart HQ behavior natively.
   ============================================================ */

/* ──────────────────────────────────────────────────────────────
   Neutralize Dawn's <cart-drawer> renderContents (and <cart-notification>).
   When Dawn's product-form submits, it fetches /cart/add WITH a `sections`
   param then calls cart.renderContents(response) which re-renders large
   chunks of the page (slow, ~300-800ms perceived). Our custom slide cart
   already refreshes via the window.fetch intercept further below, so the
   Dawn re-render is wasted work that makes Add-to-cart feel sluggish.
   ────────────────────────────────────────────────────────────── */
(function patchDawnCart() {
  function patch() {
    if (!window.customElements) return;
    ['cart-drawer', 'cart-notification'].forEach((tag) => {
      const Cls = customElements.get(tag);
      if (!Cls || !Cls.prototype) return;
      if (Cls.prototype.__pawsPatchedRenderContents) return;
      Cls.prototype.__pawsPatchedRenderContents = true;
      Cls.prototype.renderContents = function () { /* no-op: our slide cart handles refresh */ };
      if (typeof Cls.prototype.getSectionsToRender === 'function') {
        Cls.prototype.getSectionsToRender = function () { return []; };
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch);
  } else {
    patch();
  }
  setTimeout(patch, 300);
  setTimeout(patch, 1200);
})();

/* ──────────────────────────────────────────────────────────────
   Individual product PDP enhancements:
   - Reorder DOM so variant pickers (Color / Tamaños) sit RIGHT ABOVE
     the buy buttons.
   - Replace the Shopify accelerated checkout (Shop Pay vibrant button)
     with a black-outline "Comprar ahora" pill that matches the
     "Agregar al carrito" CTA size.
   - Auto-open the slide cart after Add-to-cart (safety net in addition
     to the window.fetch intercept further down).
   ────────────────────────────────────────────────────────────── */
(function enhanceProductPDP() {
  function getMoneyFormat() { return (window.Shopify && Shopify.money_format) || '${{amount}}'; }
  function formatCLP(cents) {
    return '$' + Math.round((Number(cents) || 0) / 100).toLocaleString('es-CL').replace(/,/g, '.');
  }

  function reorder(info) {
    const variantPicker = info.querySelector('variant-selects, variant-radios');
    const buttons = info.querySelector('.product-form__buttons');
    if (!variantPicker || !buttons) return;
    if (variantPicker.dataset.pawsReordered === 'true') return;
    // Only move if currently AFTER the buttons in DOM order.
    const variantBeforeButtons = variantPicker.compareDocumentPosition(buttons) & Node.DOCUMENT_POSITION_FOLLOWING;
    if (variantBeforeButtons) {
      variantPicker.dataset.pawsReordered = 'true';
      return; // already above
    }
    buttons.parentNode.insertBefore(variantPicker, buttons);
    variantPicker.dataset.pawsReordered = 'true';
  }

  function injectBuyNow(info) {
    const buttons = info.querySelector('.product-form__buttons');
    const submit = buttons && buttons.querySelector('.product-form__submit');
    if (!buttons || !submit) return;
    if (buttons.querySelector('[data-paws-buy-now]')) return;

    const buyNow = document.createElement('button');
    buyNow.type = 'button';
    buyNow.className = 'paws-buy-now button button--full-width';
    buyNow.setAttribute('data-paws-buy-now', '');
    buyNow.innerHTML = '<span>Comprar ahora</span>';

    // Insert right after the submit (Agregar al carrito).
    submit.parentNode.insertBefore(buyNow, submit.nextSibling);

    buyNow.addEventListener('click', async function (ev) {
      ev.preventDefault();
      if (buyNow.disabled) return;
      const form = submit.closest('form[action*="/cart/add"]') || info.querySelector('form[action*="/cart/add"]');
      if (!form) { window.location = '/cart'; return; }
      buyNow.disabled = true;
      const origHTML = buyNow.innerHTML;
      buyNow.innerHTML = '<span>Procesando…</span>';
      try {
        const formData = new FormData(form);
        // Use the original (non-intercepted) fetch so our slide cart doesn't pop
        // open just before redirect.
        const fetchFn = window.__paws_original_fetch || window.fetch;
        const res = await fetchFn('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        if (!res.ok) throw new Error('add failed ' + res.status);
        if (typeof window.PAWS_FS_GATE === 'function') { window.PAWS_FS_GATE('/checkout'); } else { window.location.href = '/checkout'; }
      } catch (e) {
        console.error('[paws-buy-now]', e);
        buyNow.disabled = false;
        buyNow.innerHTML = origHTML;
        alert('Hubo un problema. Intenta nuevamente.');
      }
    });
  }

  function attachAddToCartOpener(info) {
    const submit = info.querySelector('.product-form__submit');
    if (!submit || submit.dataset.pawsOpenerAttached === 'true') return;
    submit.dataset.pawsOpenerAttached = 'true';
    submit.addEventListener('click', function () {
      // Safety net: after the form submit + fetch completes, open slide cart.
      // The fetch intercept already triggers this; this handler covers cases
      // where the intercept didn't catch (e.g. theme overrides).
      setTimeout(function () {
        if (typeof window.PAWS_CART_UPDATE === 'function') {
          window.PAWS_CART_UPDATE().then(function () {
            if (typeof window.PAWS_CART_OPEN === 'function') window.PAWS_CART_OPEN();
          });
        } else if (typeof window.PAWS_CART_OPEN === 'function') {
          window.PAWS_CART_OPEN();
        }
      }, 600);
    });
  }

  function disableSoldOutVariants(info) {
    const vs = info.querySelector('variant-selects, variant-radios');
    if (!vs) return;
    if (vs.dataset.pawsSoldOutSetup === 'true') {
      vs.__pawsRefresh && vs.__pawsRefresh();
      return;
    }
    const scriptEl = vs.querySelector('script[type="application/json"]');
    if (!scriptEl) return;
    let variants;
    try { variants = JSON.parse(scriptEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;
    vs.dataset.pawsSoldOutSetup = 'true';

    function positionFromInput(inp) {
      const name = (inp.name || '').replace(/[\r\n]/g, '').trim();
      const m = name.match(/-(\d+)$/);
      return m ? parseInt(m[1], 10) : null;
    }

    function apply() {
      const current = {};
      vs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        if (inp.checked) {
          const pos = positionFromInput(inp);
          if (pos) current[pos] = inp.value;
        }
      });
      vs.querySelectorAll('select').forEach(function (sel) {
        const pos = parseInt(sel.dataset.optionPosition || '0', 10);
        if (pos) current[pos] = sel.value;
      });

      vs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        const pos = positionFromInput(inp);
        if (!pos) return;
        const candidate = Object.assign({}, current, {});
        candidate[pos] = inp.value;
        const match = variants.find(function (v) {
          return Object.keys(candidate).every(function (p) { return v['option' + p] === candidate[p]; });
        });
        const available = !!(match && match.available);
        inp.disabled = !available;
        let label = null;
        try { label = vs.querySelector('label[for="' + CSS.escape(inp.id) + '"]'); } catch (e) {}
        if (!label) label = inp.nextElementSibling;
        if (label) label.classList.toggle('paws-sold-out', !available);
      });

      vs.querySelectorAll('select').forEach(function (sel) {
        const pos = parseInt(sel.dataset.optionPosition || '0', 10);
        if (!pos) return;
        Array.from(sel.options).forEach(function (opt) {
          const candidate = Object.assign({}, current, {});
          candidate[pos] = opt.value;
          const match = variants.find(function (v) {
            return Object.keys(candidate).every(function (p) { return v['option' + p] === candidate[p]; });
          });
          opt.disabled = !(match && match.available);
        });
      });
    }
    vs.__pawsRefresh = apply;
    apply();
    vs.addEventListener('change', function () { setTimeout(apply, 60); });
  }

  function run() {
    const infos = document.querySelectorAll('.product__info-container, product-info');
    infos.forEach(function (info) {
      reorder(info);
      injectBuyNow(info);
      attachAddToCartOpener(info);
      disableSoldOutVariants(info);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1500);
})();

(function () {
  'use strict';

  const root = document.getElementById('paws-cart');
  if (!root) return;

  const CURRENCY = root.dataset.currency || 'CLP';
  const SHIPPING_THRESHOLD = parseInt(root.dataset.shippingThreshold || '0', 10);
  const FREE_SHIPPING_LABEL = root.dataset.freeShippingLabel || 'Envío Gratis';
  const UPSELL_COUNT = parseInt(root.dataset.upsellCount || '6', 10);

  const drawerEl = root.querySelector('[data-paws-cart-drawer]');
  const overlayEl = root.querySelector('[data-paws-cart-overlay]');
  const closeBtn = root.querySelector('[data-paws-cart-close]');
  const itemsEl = root.querySelector('[data-paws-cart-items]');
  const emptyEl = root.querySelector('[data-paws-cart-empty]');
  const footerEl = root.querySelector('[data-paws-cart-footer]');
  const extrasEl = root.querySelector('[data-paws-cart-extras]');
  const totalEl = root.querySelector('[data-paws-cart-total]');
  const countEl = root.querySelector('[data-paws-cart-count]');
  const upsellEl = root.querySelector('[data-paws-cart-upsell]');
  const upsellGridEl = root.querySelector('[data-paws-cart-upsell-grid]');
  const rewardsEl = root.querySelector('[data-paws-cart-rewards]');
  const rewardsTextEl = root.querySelector('[data-paws-cart-rewards-text]');
  const rewardsRemainingEl = root.querySelector('[data-paws-cart-rewards-remaining]');
  const rewardsProgressEl = root.querySelector('[data-paws-cart-rewards-progress]');
  const discountFormEl = root.querySelector('[data-paws-cart-discount-form]');
  const discountInputEl = root.querySelector('[data-paws-cart-discount-input]');
  const discountApplyBtn = root.querySelector('[data-paws-cart-discount-apply]');
  const discountMsgEl = root.querySelector('[data-paws-cart-discount-msg]');
  const discountTagsEl = root.querySelector('[data-paws-cart-discount-tags]');

  /* ─────────── helpers ─────────── */
  const formatCLP = (cents) => {
    const amount = Math.round((Number(cents) || 0) / 100);
    return '$' + amount.toLocaleString('es-CL').replace(/,/g, '.');
  };

  // Shopify Ajax API returns CLP prices ×100 (cents-style). Divide by 100 to display.
  const formatMoney = (cents) => {
    let n = Math.round((Number(cents) || 0) / 100);
    return '$' + n.toLocaleString('es-CL').replace(/,/g, '.');
  };
  // /recommendations/products.json returns price as integer CLP (not ×100). Use this:
  const formatPriceRaw = (rawPrice) => {
    let n = Math.round(Number(rawPrice) || 0);
    return '$' + n.toLocaleString('es-CL').replace(/,/g, '.');
  };
  // SHIPPING_THRESHOLD comes from data attribute as plain integer CLP (54990) — display as-is.
  const formatThreshold = (n) => '$' + (Number(n) || 0).toLocaleString('es-CL').replace(/,/g, '.');

  const escapeHtml = (s) => String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const removeIcon = '<svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="currentColor" fill-rule="nonzero"/></svg>';

  /* ─────────── state ─────────── */
  let lastCart = null;
  let isOpen = false;

  /* ─────────── open / close ─────────── */
  function open() {
    isOpen = true;
    root.setAttribute('data-paws-cart-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('paws-cart-open', 'paws-cart-active');
    // Refresh on open
    refresh();
  }

  function close() {
    isOpen = false;
    root.setAttribute('data-paws-cart-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    // Remove our class
    document.body.classList.remove('paws-cart-open');
    // Also clean up any scroll-lock classes left over by other apps / theme
    // (Dawn cart-drawer, AMP slidecart, PageFly, etc).
    document.body.classList.remove('overflow-hidden', 'modal-open', 'no-scroll', 'cart-drawer-open');
    // Restore inline styles in case any library set them
    if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = '';
    if (document.body.style.position === 'fixed') document.body.style.position = '';
    // Close native Dawn cart-drawer if it left itself open
    const dawnDrawer = document.querySelector('cart-drawer.active, cart-drawer.animate');
    if (dawnDrawer) dawnDrawer.classList.remove('active', 'animate');
  }

  /* ─────────── fetch cart ─────────── */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Cart fetch failed');
    const cart = await res.json();
    lastCart = cart;
    return cart;
  }

  /* ─────────── render ─────────── */
  function renderItems(cart) {
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      if (extrasEl) extrasEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;
    if (extrasEl) extrasEl.hidden = false;

    // Render synchronously without variants (we'll enrich asynchronously)
    itemsEl.innerHTML = cart.items.map((item) => {
      const imgUrl = item.image
        ? item.image.replace(/(\.\w+)(\?.*)?$/, (m, ext, q) => '_120x' + ext + (q || ''))
        : '';
      const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title.replace(/ \/ /g, ' · ')
        : '';
      const hasDiscount = item.original_line_price !== item.final_line_price;
      /* 2026-09-10: precio anterior por unidad (centavos) para mostrar tachado durante la oferta de lanzamiento. Quitar al terminar. */
      const RT_COMPARE = { ritual: 1490000 };
      const cmpUnit = RT_COMPARE[item.handle];
      const strikeAmt = (cmpUnit && cmpUnit * item.quantity > item.final_line_price) ? cmpUnit * item.quantity : (hasDiscount ? item.original_line_price : 0);
      const priceHtml = strikeAmt
        ? `<span class="paws-cart-item__price-strike">${formatMoney(strikeAmt)}</span>
           <span class="paws-cart-item__price-sale">${formatMoney(item.final_line_price)}</span>`
        : `<span class="paws-cart-item__price-current">${formatMoney(item.final_line_price)}</span>`;

      return `
        <li class="paws-cart-item"
            data-paws-cart-item
            data-line-key="${escapeHtml(item.key)}"
            data-variant-id="${item.variant_id}"
            data-product-id="${item.product_id}"
            data-product-handle="${escapeHtml(item.handle || '')}">
          <a class="paws-cart-item__image" href="${escapeHtml(item.url)}" aria-hidden="true" tabindex="-1">
            ${imgUrl ? `<img src="${escapeHtml(imgUrl)}" alt="${escapeHtml(item.product_title)}" loading="lazy" width="80" height="80">` : ''}
          </a>
          <div class="paws-cart-item__main">
            <div class="paws-cart-item__head">
              <div class="paws-cart-item__head-text">
                <a class="paws-cart-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
                ${variantLabel ? `<p class="paws-cart-item__variant" data-paws-cart-variant-label>${escapeHtml(variantLabel)}</p>` : ''}
                <div class="paws-cart-item__options" data-paws-cart-item-options></div>
              </div>
              <button type="button" class="paws-cart-item__remove" data-paws-cart-remove aria-label="Quitar">${removeIcon}</button>
            </div>
            <div class="paws-cart-item__foot">
              <div class="paws-cart-item__qty">
                <button type="button" class="paws-cart-item__qty-btn" data-paws-cart-qty-decrease aria-label="Disminuir">−</button>
                <input type="number" class="paws-cart-item__qty-input" value="${item.quantity}" min="0" data-paws-cart-qty-input aria-label="Cantidad">
                <button type="button" class="paws-cart-item__qty-btn" data-paws-cart-qty-increase aria-label="Aumentar">+</button>
              </div>
              <div class="paws-cart-item__price">${priceHtml}</div>
            </div>
          </div>
        </li>
      `;
    }).join('');

    bindItemEvents();
    // Asynchronously enrich each item with variant selectors
    cart.items.forEach((item) => enrichItemWithVariantSelectors(item));
  }

  // Cache product data fetched from /products/<handle>.js to avoid duplicate fetches
  const productCache = {};

  async function fetchProductData(handle) {
    if (!handle) return null;
    if (productCache[handle]) return productCache[handle];
    try {
      const res = await originalFetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      const data = await res.json();
      productCache[handle] = data;
      return data;
    } catch (e) {
      console.warn('product fetch failed:', handle, e);
      return null;
    }
  }

  async function enrichItemWithVariantSelectors(item) {
    const handle = item.handle;
    if (!handle) return;
    const itemEl = itemsEl.querySelector(`[data-line-key="${CSS.escape(item.key)}"]`);
    if (!itemEl) return;
    const optionsEl = itemEl.querySelector('[data-paws-cart-item-options]');
    if (!optionsEl) return;

    const product = await fetchProductData(handle);
    if (!product || !product.variants || !product.options) return;
    // Normalize options: in /products/<h>.js can be array of strings OR objects {name, values}
    const optionsList = product.options.map((o) => typeof o === 'string' ? { name: o, values: null } : o);
    // Single-default-variant products → don't render selectors
    if (product.variants.length === 1 && (!optionsList.length || optionsList[0].name === 'Title')) return;

    const currentVariant = product.variants.find(v => v.id === item.variant_id);
    if (!currentVariant) return;

    // Build a select per option — but ONLY if the option has 2+ values (otherwise skip)
    // Mark unavailable combinations as disabled so the user can't pick a sold-out variant.
    // Current selection by position (used to evaluate availability of each candidate).
    const currentSelection = {};
    optionsList.forEach((_o, i) => { currentSelection[i + 1] = currentVariant[`option${i + 1}`]; });

    const selectorsHtml = optionsList.map((opt, idx) => {
      const optName = opt.name;
      const pos = idx + 1;
      let uniqueVals = opt.values;
      if (!uniqueVals || uniqueVals.length === 0) {
        uniqueVals = [];
        product.variants.forEach((v) => {
          const val = v[`option${pos}`];
          if (val && !uniqueVals.includes(val)) uniqueVals.push(val);
        });
      }
      // Filter out values where NO variant with that value is available
      // (e.g. color "Amarillo" with all sizes sold-out → exclude entirely)
      uniqueVals = uniqueVals.filter((val) => {
        return product.variants.some((v) => v[`option${pos}`] === val && v.available);
      });
      if (uniqueVals.length < 2) return '';
      const currentVal = currentVariant[`option${pos}`];
      return `
        <select class="paws-cart-item__option-select"
                data-paws-cart-item-option-position="${pos}"
                data-paws-cart-item-option-name="${escapeHtml(optName)}"
                aria-label="${escapeHtml(optName)}">
          ${uniqueVals.map((v) => {
            const candidate = Object.assign({}, currentSelection);
            candidate[pos] = v;
            const match = product.variants.find((variant) => {
              return Object.keys(candidate).every((p) => variant[`option${p}`] === candidate[p]);
            });
            const isAvail = !!(match && match.available);
            const dis = isAvail ? '' : ' disabled';
            const lbl = isAvail ? v : v + ' — Agotado';
            return `<option value="${escapeHtml(v)}"${v === currentVal ? ' selected' : ''}${dis}>${escapeHtml(lbl)}</option>`;
          }).join('')}
        </select>
      `;
    }).join('');

    if (!selectorsHtml.trim()) return;
    optionsEl.innerHTML = selectorsHtml;

    // Recompute disabled across selects based on currently selected values.
    function refreshDisabled() {
      const selects = optionsEl.querySelectorAll('select[data-paws-cart-item-option-position]');
      const cur = {};
      selects.forEach((s) => { cur[parseInt(s.dataset.pawsCartItemOptionPosition, 10)] = s.value; });
      selects.forEach((s) => {
        const pos = parseInt(s.dataset.pawsCartItemOptionPosition, 10);
        Array.from(s.options).forEach((opt) => {
          const candidate = Object.assign({}, cur);
          candidate[pos] = opt.value;
          const match = product.variants.find((variant) => {
            return Object.keys(candidate).every((p) => variant[`option${p}`] === candidate[p]);
          });
          const avail = !!(match && match.available);
          opt.disabled = !avail;
          // Update label suffix " — Agotado"
          const baseVal = opt.value;
          const wantLabel = avail ? baseVal : baseVal + ' — Agotado';
          if (opt.textContent !== wantLabel) opt.textContent = wantLabel;
        });
      });
    }

    optionsEl.querySelectorAll('select').forEach((sel) => {
      sel.addEventListener('change', () => {
        refreshDisabled();
        onVariantSelectorChange(itemEl, product, item);
      });
    });
  }

  async function onVariantSelectorChange(itemEl, product, originalItem) {
    const selects = itemEl.querySelectorAll('[data-paws-cart-item-option-position]');
    const selected = [];
    selects.forEach((s) => selected.push(s.value));
    // Find matching variant
    const newVariant = product.variants.find((v) => {
      return selected.every((val, idx) => v[`option${idx + 1}`] === val);
    });
    if (!newVariant) {
      alert('Esa combinación no está disponible.');
      return;
    }
    if (newVariant.id === originalItem.variant_id) return;
    if (!newVariant.available) {
      alert('Esa variante está agotada.');
      return;
    }

    try {
      itemEl.style.opacity = '0.5';
      const qty = originalItem.quantity;

      // Swap ATÓMICO de la variante: modifica la línea existente en vez de
      // agregar una nueva. /cart/update.js con `updates` por variant id quita
      // la talla vieja (0) y deja la nueva en el MISMO lugar, en una sola
      // petición. Ventajas vs el viejo add+change:
      //   - sin duplicados (el add+change podía dejar 2 líneas si el remove
      //     fallaba con HTTP 400 "parámetro lineal no válido"),
      //   - conserva los descuentos aplicados (no se limpia el carrito),
      //   - al ser atómico, la cantidad total se mantiene, así que los
      //     descuentos con mínimo de cantidad (Mix&Match) siguen vigentes.
      const res = await originalFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: { [originalItem.variant_id]: 0, [newVariant.id]: qty } }),
      });
      if (!res.ok) throw new Error('update failed ' + res.status);

      await refresh();
      // re-evaluate offers. These are the standard event names used by most
      // Shopify cart drawers and bundle apps.
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'paws-slide-cart' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'paws-slide-cart' } }));
        document.dispatchEvent(new CustomEvent('shopify:cart:updated', { detail: { source: 'paws-slide-cart' } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { source: 'paws-slide-cart' } }));
      } catch (e) { console.warn('cart event dispatch failed:', e); }
    } catch (e) {
      console.error('Variant swap failed:', e);
      alert('Hubo un problema cambiando la variante.');
      itemEl.style.opacity = '1';
    }
  }

  function renderRewards(cart) {
    if (!rewardsEl || !SHIPPING_THRESHOLD) return;
    const threshold = SHIPPING_THRESHOLD * 100; // cents
    const total = cart.total_price;
    const remaining = Math.max(0, threshold - total);
    const pct = Math.min(100, (total / threshold) * 100);

    if (rewardsProgressEl) rewardsProgressEl.style.width = pct + '%';

    // Update threshold display (in case server-side didn't render it correctly)
    const thresholdDisplay = root.querySelector('[data-paws-cart-threshold-display]');
    if (thresholdDisplay) thresholdDisplay.textContent = formatThreshold(SHIPPING_THRESHOLD);

    if (remaining === 0) {
      rewardsEl.classList.add('paws-cart__rewards--reached');
      if (rewardsTextEl) {
        rewardsTextEl.innerHTML = `🎉 ¡Tienes <strong>${FREE_SHIPPING_LABEL}</strong>!`;
      }
    } else {
      rewardsEl.classList.remove('paws-cart__rewards--reached');
      if (rewardsTextEl) {
        rewardsTextEl.innerHTML = `Agrega <span data-paws-cart-rewards-remaining>${formatMoney(remaining)}</span> más y obtén <strong>${FREE_SHIPPING_LABEL}</strong>`;
      }
    }
  }

  function renderTotals(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Update sticky cart icon badge
    const stickyEl = document.querySelector('[data-paws-cart-sticky]');
    const stickyCountEl = document.querySelector('[data-paws-cart-sticky-count]');
    if (stickyCountEl) {
      stickyCountEl.textContent = cart.item_count;
      stickyCountEl.hidden = cart.item_count === 0;
    }
    if (stickyEl) {
      stickyEl.dataset.empty = cart.item_count === 0 ? 'true' : 'false';
    }

    // Also update header cart icon if found
    const iconBubbles = document.querySelectorAll('#cart-icon-bubble [data-cart-count], #cart-icon-bubble .cart-count-bubble span:first-child, .cart-count-bubble [aria-hidden="true"], .header__cart-count');
    iconBubbles.forEach((el) => {
      if (el.textContent !== undefined) {
        const num = el.textContent.match(/\d+/);
        if (num !== null || el.classList.contains('cart-count') || el.dataset.cartCount !== undefined) {
          el.textContent = cart.item_count;
        }
      }
    });
  }

  /* MD curated upsell handles — accesorios atractivos según contenido del cart.
     Las cajas NO se ofrecen como upsell (no convierten). Universal: bolsita lavar +
     scrunchies + bolsa de seda. Si hay antifaz, añadir tiras nasales y tapones. */
  function getCuratedUpsellHandles(cart) {
    const inCart = new Set();
    for (const it of (cart.items || [])) {
      if (it.handle) inCart.add(it.handle);
    }
    const handlesText = Array.from(inCart).join(' ');
    const hasAntifaz = /antifaz|turbante|3d-dormir/i.test(handlesText);
    const hasFunda = /\bfunda\b|funda-/i.test(handlesText);

    const ordered = [];
    // RITUAL siempre primero en el upsell del carrito
    ordered.push('ritual');
    // Universal silk accessories — work for any silk product
    ordered.push('laundry-bag');
    ordered.push('scrunchies-seda');
    ordered.push('bolsa-de-seda-para-antifaz-tamano-l');
    // Conditional: antifaz → sleep boosters
    if (hasAntifaz) {
      ordered.push('tiras-nasales-dormir');
      ordered.push('tapones-para-dormir');
    }
    // Fallback extras (cross-sell de la familia silk completa)
    if (!hasAntifaz) ordered.push('antifaz-seda-king');
    if (!hasFunda) ordered.push('funda-almohada-seda-king');

    /* Strip handles already in cart, dedupe, cap at UPSELL_COUNT */
    const seen = new Set();
    const filtered = [];
    for (const h of ordered) {
      if (inCart.has(h)) continue;
      if (seen.has(h)) continue;
      seen.add(h);
      filtered.push(h);
      if (filtered.length >= UPSELL_COUNT) break;
    }
    return filtered;
  }

  async function renderUpsell(cart) {
    if (!upsellEl || !upsellGridEl) return;
    if (cart.item_count === 0) {
      upsellEl.hidden = true;
      return;
    }
    const handles = getCuratedUpsellHandles(cart);
    if (handles.length === 0) {
      upsellEl.hidden = true;
      return;
    }
    try {
      /* Fetch /products/<handle>.js for each curated handle (uses productCache) */
      const fetched = await Promise.all(handles.map((h) => fetchProductData(h)));
      const products = fetched.filter(Boolean).map((p) => {
        /* Normalize shape to match the old /recommendations response.
           RITUAL: usar la imagen de la variante (packshot fondo blanco), no la featured con texto. */
        const variantImg = (p.handle === 'ritual' && p.variants && p.variants[0] && p.variants[0].featured_image && p.variants[0].featured_image.src) || null;
        return {
          id: p.id,
          title: p.title,
          url: p.url,
          featured_image: variantImg || (p.featured_image && (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src)) || (p.images && p.images[0]),
          variants: p.variants,
        };
      }).filter((p) => {
        return !cart.items.some((it) => it.product_id === p.id);
      }).slice(0, UPSELL_COUNT);
      if (products.length === 0) {
        upsellEl.hidden = true;
        return;
      }
      upsellEl.hidden = false;
      upsellGridEl.innerHTML = products.map((p) => {
        const firstAvailable = (p.variants || []).find((v) => v.available) || (p.variants || [])[0];
        if (!firstAvailable) return '';
        const compare = firstAvailable.compare_at_price;
        const price = firstAvailable.price;
        const hasCompare = compare && Number(compare) > Number(price);
        return `
          <div class="paws-cart__upsell-card" data-paws-cart-upsell-card>
            <a href="${escapeHtml(p.url)}" class="paws-cart__upsell-card-image">
              <img src="${escapeHtml(p.featured_image || (p.images && p.images[0]) || '')}" alt="${escapeHtml(p.title)}" loading="lazy">
            </a>
            <a href="${escapeHtml(p.url)}" style="text-decoration:none;color:inherit;">
              <p class="paws-cart__upsell-card-title">${escapeHtml(p.title)}</p>
            </a>
            <div class="paws-cart__upsell-card-price">
              ${hasCompare ? `<span class="paws-cart__upsell-card-price-strike">${formatMoney(compare)}</span>` : ''}
              <span class="paws-cart__upsell-card-price-sale">${formatMoney(price)}</span>
            </div>
            <button type="button" class="paws-cart__upsell-card-button" data-paws-cart-upsell-add data-variant-id="${firstAvailable.id}">AÑADIR</button>
          </div>
        `;
      }).join('');

      // Bind upsell add buttons
      upsellGridEl.querySelectorAll('[data-paws-cart-upsell-add]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          const oldText = btn.textContent;
          btn.textContent = '...';
          try {
            await originalFetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] }),
            });
            await refresh();
          } catch (e) {
            console.error(e);
          } finally {
            btn.disabled = false;
            btn.textContent = oldText;
          }
        });
      });
    } catch (e) {
      console.warn('Upsell fetch failed:', e);
      upsellEl.hidden = true;
    }
  }

  async function refresh() {
    try {
      const cart = await fetchCart();
      renderItems(cart);
      renderRewards(cart);
      renderTotals(cart);
      renderDiscount(cart);
      renderUpsell(cart);
    } catch (e) {
      console.error('Cart refresh failed:', e);
    }
  }

  /* ─────────── item events (qty / remove) ─────────── */
  let qtyDebounceTimers = {};

  function bindItemEvents() {
    itemsEl.querySelectorAll('[data-paws-cart-item]').forEach((itemEl) => {
      const lineKey = itemEl.dataset.lineKey;
      const decreaseBtn = itemEl.querySelector('[data-paws-cart-qty-decrease]');
      const increaseBtn = itemEl.querySelector('[data-paws-cart-qty-increase]');
      const qtyInput = itemEl.querySelector('[data-paws-cart-qty-input]');
      const removeBtn = itemEl.querySelector('[data-paws-cart-remove]');

      const setQty = async (newQty) => {
        try {
          itemEl.style.opacity = '0.5';
          await originalFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: Math.max(0, newQty) }),
          });
          await refresh();
        } catch (e) {
          console.error(e);
          itemEl.style.opacity = '1';
        }
      };

      if (decreaseBtn) decreaseBtn.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 0;
        setQty(v - 1);
      });
      if (increaseBtn) increaseBtn.addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10) || 0;
        setQty(v + 1);
      });
      if (qtyInput) qtyInput.addEventListener('change', () => {
        const v = parseInt(qtyInput.value, 10) || 0;
        clearTimeout(qtyDebounceTimers[lineKey]);
        qtyDebounceTimers[lineKey] = setTimeout(() => setQty(v), 250);
      });
      if (removeBtn) removeBtn.addEventListener('click', () => setQty(0));
    });
  }

  /* ─────────── fetch intercept ─────────── */
  const originalFetch = window.fetch.bind(window);
  window.__paws_original_fetch = originalFetch;
  // Avoid double-wrapping
  if (!window.__paws_cart_intercepted) {
    window.__paws_cart_intercepted = true;
    window.fetch = async function (input, init) {
      const url = (typeof input === 'string') ? input : (input && input.url);
      // Accept both /cart/add and /cart/add.js, with optional querystring or fragment.
      const isCartMutation = url && /\/cart\/(add|change|update|clear)(\.js)?(\?|#|$)/.test(url);
      const isCartAdd = url && /\/cart\/add(\.js)?(\?|#|$)/.test(url);
      const res = await originalFetch(input, init);
      if (isCartMutation && res.ok) {
        setTimeout(() => {
          refresh().then(() => {
            if (isCartAdd) open();
          });
        }, 50);
      }
      return res;
    };
  }

  /* ─────────── header cart icon click ─────────── */
  document.querySelectorAll('#cart-icon-bubble, a[href="/cart"], [data-cart-link]').forEach((el) => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      open();
    });
  });

  /* ─────────── overlay & close ─────────── */
  if (overlayEl) overlayEl.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) close();
  });

  /* ─────────── sticky cart icon ─────────── */
  const stickyBtn = document.querySelector('[data-paws-cart-sticky]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', (ev) => { ev.preventDefault(); open(); });
  }

  /* ─────────── clear cart button ─────────── */
  const clearBtn = root.querySelector('[data-paws-cart-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', async () => {
      clearBtn.disabled = true;
      clearBtn.style.opacity = '0.5';
      try {
        await originalFetch('/cart/clear.js', { method: 'POST' });
        await refresh();
      } catch (e) {
        console.error('Clear failed:', e);
      } finally {
        clearBtn.disabled = false;
        clearBtn.style.opacity = '1';
      }
    });
  }

  /* ─────────── discount code (campo en el footer del carrito) ─────────── */
  function discountMsg(text, kind) {
    if (!discountMsgEl) return;
    if (!text) {
      discountMsgEl.hidden = true;
      discountMsgEl.textContent = '';
      discountMsgEl.removeAttribute('data-kind');
      return;
    }
    discountMsgEl.hidden = false;
    discountMsgEl.textContent = text;
    discountMsgEl.setAttribute('data-kind', kind || 'info');
  }

  function discountAmountForCode(cart, code) {
    const lc = String(code || '').toLowerCase();
    let amount = 0;
    (cart.cart_level_discount_applications || []).forEach((a) => {
      if (a && a.title && a.title.toLowerCase() === lc) amount += Number(a.total_allocated_amount || 0);
    });
    if (amount === 0) {
      (cart.items || []).forEach((it) => {
        (it.line_level_discount_allocations || it.discounts || []).forEach((d) => {
          const t = (d && (d.discount_application ? d.discount_application.title : d.title)) || '';
          if (t.toLowerCase() === lc) amount += Number(d.amount || 0);
        });
      });
    }
    return amount;
  }

  function renderDiscount(cart) {
    if (!discountTagsEl) return;
    const codes = (cart.discount_codes || []).filter((d) => d && d.applicable && d.code);
    if (!codes.length) { discountTagsEl.innerHTML = ''; return; }
    discountTagsEl.innerHTML = codes.map((d) => {
      const amt = discountAmountForCode(cart, d.code);
      const amtLabel = amt > 0 ? '-' + formatMoney(amt) : 'Aplicado';
      return `<li class="paws-cart__discount-tag" data-code="${escapeHtml(d.code)}">
          <span class="paws-cart__discount-tag-check" aria-hidden="true">✓</span>
          <span class="paws-cart__discount-tag-code">${escapeHtml(d.code)}</span>
          <span class="paws-cart__discount-tag-amount">${amtLabel}</span>
          <button type="button" class="paws-cart__discount-tag-remove" data-paws-cart-discount-remove aria-label="Quitar código">${removeIcon}</button>
        </li>`;
    }).join('');
    discountTagsEl.querySelectorAll('[data-paws-cart-discount-remove]').forEach((b) => {
      b.addEventListener('click', removeDiscount);
    });
  }

  async function applyDiscount(rawCode) {
    const code = String(rawCode || '').trim();
    if (!code) { discountMsg('Ingresa un código.', 'error'); return; }
    if (discountApplyBtn) discountApplyBtn.disabled = true;
    discountMsg('Aplicando…', 'info');
    try {
      await originalFetch('/discount/' + encodeURIComponent(code) + '?_t=' + Date.now(), {
        method: 'GET', credentials: 'include', redirect: 'follow',
      }).then((r) => r && r.text && r.text());
      await new Promise((r) => setTimeout(r, 150));
      const cart = await fetchCart();
      const entry = (cart.discount_codes || []).find(
        (d) => d && d.code && d.code.toLowerCase() === code.toLowerCase()
      );
      if (entry && entry.applicable) {
        if (discountInputEl) discountInputEl.value = '';
        discountMsg('', null);
        renderItems(cart); renderRewards(cart); renderTotals(cart); renderDiscount(cart); renderUpsell(cart);
      } else {
        await originalFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '' }),
        }).catch(() => {});
        /* Los 4 codigos del raspe exigen compra minima $39.900: mensaje especifico */
        const minCodes = ['md5', 'md8', 'md10', 'envio24'];
        const belowMin = (cart.items_subtotal_price || cart.total_price || 0) < 3990000;
        if (minCodes.includes(code.toLowerCase()) && belowMin) {
          discountMsg('El código ' + code.toUpperCase() + ' requiere una compra mínima de $39.900.', 'error');
        } else {
          discountMsg('Código inválido o no aplicable a tu carrito.', 'error');
        }
        await refresh();
      }
    } catch (e) {
      console.error('[md-cart] applyDiscount', e);
      discountMsg('No pudimos aplicar el código. Intenta nuevamente.', 'error');
    } finally {
      if (discountApplyBtn) discountApplyBtn.disabled = false;
    }
  }

  async function removeDiscount() {
    try {
      await originalFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });
      discountMsg('', null);
      await refresh();
    } catch (e) {
      console.error('[md-cart] removeDiscount', e);
    }
  }

  if (discountFormEl) {
    discountFormEl.addEventListener('submit', (e) => {
      e.preventDefault();
      applyDiscount(discountInputEl ? discountInputEl.value : '');
    });
  }

  /* ─────────── PUBLIC API ─────────── */
  window.PAWS_CART_OPEN = open;
  window.PAWS_CART_CLOSE = close;
  window.PAWS_CART_UPDATE = refresh;
  // Compat alias for existing bundle JS
  window.SLIDECART_OPEN = open;
  window.SLIDECART_CLOSE = close;
  window.SLIDECART_UPDATE = refresh;

  /* ─────────── initial bind for server-rendered items ─────────── */
  if (itemsEl) bindItemEvents();

  // Initial state from current server-rendered cart
  if (typeof Shopify !== 'undefined' && Shopify.cart) {
    lastCart = Shopify.cart;
  }
  // Initial rewards/totals based on current count
  refresh();

  document.body.classList.add('paws-cart-active');
})();


/* MD email deep-link (mdqty) */
/* Emails de carrito abandonado RITUAL llegan a la PDP con ?mdqty=N:
   fija esa cantidad en el carrito (update.js = cantidad absoluta, no duplica)
   y abre el slide cart. Sin el parametro no hace nada. */
(function mdEmailRestore() {
  try {
    var params = new URLSearchParams(window.location.search);
    var qty = parseInt(params.get('mdqty') || '', 10);
    if (!qty || qty < 1 || qty > 10) return;
    var mv = params.get('mdvariant') || '';
    var variant = /^\d+$/.test(mv) ? mv : '54319643197732'; /* RITUAL 10 sachets */
    var doRestore = function () {
      var updates = {}; updates[variant] = qty;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        if (window.PAWS_CART_UPDATE) window.PAWS_CART_UPDATE();
        if (window.PAWS_CART_OPEN) setTimeout(window.PAWS_CART_OPEN, 250);
      }).catch(function () {});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', doRestore);
    else doRestore();
  } catch (e) { /* noop */ }
})();
